import EventEmitter from 'eventemitter3'

const EVENT_TRYING = 'EVENT_TRYING'
const EVENT_PROGRESS = 'EVENT_PROGRESS'
const EVENT_ACCEPT = 'EVENT_ACCEPT'
const EVENT_REJECT = 'EVENT_REJECT'
const EVENT_REDIRECT = 'EVENT_REDIRECT'
const EVENT_INITIAL = 'EVENT_INITIAL'
const EVENT_ESTABLISHING = 'EVENT_ESTABLISHING'
const EVENT_ESTABLISHED = 'EVENT_ESTABLISHED'
const EVENT_TERMINATING = 'EVENT_TERMINATING'
const EVENT_TERMINATED = 'EVENT_TERMINATED'

export default (inviter) => {
  let events = new EventEmitter()

  const callEvents = {
    emitTrying: (evt) => events?.emit(EVENT_TRYING, evt),
    emitProgress: (evt) => events?.emit(EVENT_PROGRESS, evt),
    emitAccept: (evt) => events?.emit(EVENT_ACCEPT, evt),
    emitReject: (evt) => events?.emit(EVENT_REJECT, evt),
    emitRedirect: (evt) => events?.emit(EVENT_REDIRECT, evt),

    emitInitial: () => events?.emit(EVENT_INITIAL),
    emitEstablishing: () => events?.emit(EVENT_ESTABLISHING),
    emitEstablished: () => events?.emit(EVENT_ESTABLISHED),
    emitTerminating: () => events?.emit(EVENT_TERMINATING),
    emitTerminated: () => events?.emit(EVENT_TERMINATED),

    onTrying: (cb) => once(EVENT_TRYING, cb),
    onProgress: (cb) => once(EVENT_PROGRESS, cb),
    onAccept: (cb) => once(EVENT_ACCEPT, cb),
    onReject: (cb) => once(EVENT_REJECT, cb),
    onRedirect: (cb) => once(EVENT_REDIRECT, cb),

    onInitial: (cb) => once(EVENT_INITIAL, cb),
    onEstablishing: (cb) => once(EVENT_ESTABLISHING, cb),
    onEstablished: (cb) => once(EVENT_ESTABLISHED, cb),
    onTerminating: (cb) => once(EVENT_TERMINATING, cb),
    onTerminated: (cb) => once(EVENT_TERMINATED, cb),

    destroy: () => {
      setTimeout(() => {
        inviter.events = null
        events = null
      }, 1000)
    }
  }

  const once = (eventName, cb) => {
    events.once(eventName, (msg) => cb(inviter, msg))
    return callEvents
  }

  inviter.events = callEvents

  return callEvents
}
